
export interface CheckSubscriptionStatus200Response {
  expiresAt?: string;
  hasActiveSubscription?: boolean;
  planId?: string;
  source?: string;
  status?: string;
  subscriptionId?: string;
  success?: boolean;
}
